
import Icon from 'vux/src/components/icon/index.vue'

export default {
name: 'search-input',
components: {
Icon,
},
props: {
value: {
type: [String, Number]
},
placeholder: {
type: String,
default: '',
}
},
data: function() {
return {
currentValue: '',
}
},
mounted () {
this.currentValue = this.value;
},
watch: {
value: function (val) {
this.currentValue = val;
}
},
methods: {
getImage: function (id) {
return require('@/assets/images/down6.png')
},
updateValue (event) {

this.$emit('input', this.currentValue);
},
handleClick (event) {

this.$emit('s-click', event);
},
handleEnter (event) {
this.$emit('s-enter', event);
},
handleChange (event) {

this.$emit('s-keyup', event);
}
}
}



// WEBPACK FOOTER //
// ./src/components/SearchInput.vue